<template>
  <div class="form-date-time-picker row mb-3">
    <div class="col-xl-3 text-primary mb-2">
      {{ label }}&nbsp;<template v-if="required">*</template>
    </div>
    <div class="col">

      <calendar-view
          :locale="locale"
          :startingDayOfWeek="1"
          :showDate="showDate"
          :currentPeriodLabel="formattedMonth"
          class="mb-3"

      >
        <template v-slot:header="{headerProps}">
          <calendar-view-header
              :header-props="headerProps"
              @input="setShowDate"
          />
        </template>
        <template v-slot:dayContent="{day}">
          <div v-if="!hasDayAvailableSlots(day)" class="cv-day-number" :class="{'available': hasDayAvailableSlots(day)}">
            {{ toDayNumber(day) }}
          </div>
          <button v-else type="button"
                  class="choose-day-btn btn p-1"
                  :style="isSelectedDate(day)?'opacity: 1':''"
                  :disabled="!hasDayAvailableSlots(day)"
                  @click="chooseDay(day)"
          >
            <div class="embed-responsive  ">
              <div class="embed-responsive-item"
              >
                {{ toDayNumber(day) }}
              </div>
            </div>
          </button>
        </template>
      </calendar-view>
      <input v-if="!hideTime"
             :required="required"
             type="time"
             class="form-control text-center"
             v-model="selectedTime"
             @change="chooseTime">
    </div>
  </div>
</template>

<script>
import {CalendarView, CalendarViewHeader} from "vue-simple-calendar"
import dayjs from "dayjs";


export default {
  name: "FormDateTimeInput",
  components: {CalendarView, CalendarViewHeader},
  props: {
    value: {type: String, default: ''},
    // date: {type: Date, default: () => new Date()},
    label: {type: String, default: ''},
    required: {type: Boolean, default: false},
    invalidNote: {type: String, default: 'invalid input'},
    locale: {type: String, default: 'de'},
    hideTime: {type: Boolean, default: false},
    availableSlots: {type: Array, default: () => []}
  },
  watch: {
    value(nv, ov) {
      if (nv && nv !== ov) {
        let djs = dayjs(nv);
        this.selectedDate = djs.toISOString();
        this.selectedTime = djs.format('HH:mm');
        this.showDate = djs.toDate()
        this.$forceUpdate()
      }
    }
  },
  data() {
    return {
      showDate: new Date(),
      selectedDate: '',
      selectedTime: '00:00',
    }
  },
  computed: {
    formattedMonth() {
      return dayjs(this.showDate).format('MMMM YYYY')
    }
  },
  mounted() {
    if (this.availableSlots[0] && this.availableSlots[0][0]) {
      this.chooseDay(this.availableSlots[0][0].start)
    }
  },
  methods: {
    setShowDate(d) {
      console.log('setShowDate', d)
      this.showDate = d;
    },
    chooseDay(d) {
      let [hour, minute] = this.selectedTime.split(':')
      this.$emit('input',
          dayjs(d)
              .hour(parseInt(hour))
              .minute(parseInt(minute))
              .format(this.$config.API_DATE_TIME_FORMAT)
      );
    },
    chooseTime({target}) {
      if (!target.value) {

        return
      }
      let [hour, minute] = target.value.split(':')
      this.$emit('input',
          dayjs(this.value)
              .hour(parseInt(hour))
              .minute(parseInt(minute))
              .format(this.$config.API_DATE_TIME_FORMAT)
      );
    },
    isSelectedDate(d) {
      return dayjs(d).startOf('day').unix() === dayjs(this.value).startOf('day').unix()
    },
    toDayNumber(d) {
      return dayjs(d).format('D')
    },
    hasDayAvailableSlots(day) {
      const dayString = dayjs(day).format(this.$config.API_DATE_FORMAT)
      return !!this.availableSlots.find(group => {
        if (group[0]) {
          return dayString === dayjs(group[0].start).format(this.$config.API_DATE_FORMAT)
        }

      })
    }
  }
}
</script>

